import { render, staticRenderFns } from "./ControlPicture.vue?vue&type=template&id=4c226352&scoped=true"
import script from "./ControlPicture.vue?vue&type=script&lang=js"
export * from "./ControlPicture.vue?vue&type=script&lang=js"
import style0 from "./ControlPicture.vue?vue&type=style&index=0&id=4c226352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c226352",
  null
  
)

export default component.exports